import { render, staticRenderFns } from "./dvidsVideo.vue?vue&type=template&id=46885e7a&"
import script from "./dvidsVideo.vue?vue&type=script&lang=js&"
export * from "./dvidsVideo.vue?vue&type=script&lang=js&"
import style0 from "./dvidsVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Jenkins\\jobs\\SlideShow\\branches\\release-07-00-09.6uaoor\\workspace\\Scripts\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46885e7a')) {
      api.createRecord('46885e7a', component.options)
    } else {
      api.reload('46885e7a', component.options)
    }
    module.hot.accept("./dvidsVideo.vue?vue&type=template&id=46885e7a&", function () {
      api.rerender('46885e7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "dvidsVideo.vue"
export default component.exports